import script from "./RoomEvaluation.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomEvaluation.vue?vue&type=script&setup=true&lang=js"

import "./RoomEvaluation.vue?vue&type=style&index=0&id=904d984e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-904d984e"]])

export default __exports__